(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('WorkqueueMessageController', WorkqueueMessageController);

  /* ngInject */
  function WorkqueueMessageController($timeout, $document, $filter, $state, $stateParams, $window, Flash, sessionService, workqueueService, formErrorsService, config, Upload) {
    const vm = this;

    angular.extend(vm, formErrorsService);

    vm.activate = activate;
    vm.config = config;
    vm.deleteAttachment = deleteAttachment;
    vm.downloadAttachment = downloadAttachment;
    vm.getMessage = getMessage;
    vm.getStaff = getStaff;
    vm.hasDraft = hasDraft;
    vm.messageForm = {};
    vm.messageThread = {
      question_count: 0,
      call_count: 0,
      disclosure_count: 0,
      ad_count: 0,
      policy_count: 0
    };
    vm.processMessage = processMessage;
    vm.preventDownload = preventDownload;
    vm.reassignCurrentMessage = reassignCurrentMessage;
    vm.saveAsDraft = saveAsDraft;
    vm.markDuplicate = markDuplicate;
    vm.markAnswered = markAnswered;
    vm.sessionService = sessionService;
    vm.staff = [];
    vm.updateDraft = updateDraft;
    vm.currentAttachment = null;
    vm.currentMessage = null;
    vm.currentMessageThread = null;

    vm.activate();

    function activate() {
      getMessage();
      getStaff();

      $window.bsCustomFileInput.init();
    }

    function createMessage(messageThread) {
      vm.clearFormErrors();

      let message = {
        author_id: messageThread.owner_id,
        body: messageThread.reply,
        message_thread_id: messageThread.id,
        is_draft: false,
        question_count: messageThread.question_count,
        call_count: messageThread.call_count,
        disclosure_count: messageThread.disclosure_count,
        ad_count: messageThread.ad_count,
        policy_count: messageThread.policy_count
      };

      let msgThread = {
        owner_id: messageThread.owner_id,
        owner_read_flag: true,
        user_read_flag: false
      };

      if (messageThread.attachments != null) {
        let uploadAttachments = Upload.upload({
          url: `${config.complianceServicesApiEndpoint}/api/workqueue`,
          method: 'POST',
          data: { message: message, message_thread: msgThread, attachments: messageThread.attachments },
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        });

        uploadAttachments.then(response => {
          $timeout(() => {
            _saveMessageSuccess(response);
          });
        }, response => {
          _saveMessageFailure(response);
        });
      } else {
        workqueueService(sessionService.getAuthToken()).update({id: messageThread.id, message_thread: msgThread});
        workqueueService(sessionService.getAuthToken()).save({ id: messageThread.id }, message, _saveMessageSuccess, _saveMessageFailure);
      }
    }

    function downloadAttachment(attachment) {
      workqueueService(sessionService.getAuthToken()).downloadAttachment({id: vm.messageThread.id, attachmentId: attachment.id}, (response) => {
        let downloadElement = $document.createElement('a');
        downloadElement.href = `data:${attachment.asset_content_type},${encodeURI(response.content)}`;
        downloadElement.target = '_blank';
        downloadElement.download = attachment.asset_file_name;
        downloadElement.click();
      });
    }

    function deleteAttachment(message, attachment) {      
      console.log(message);
      console.log(attachment);
      workqueueService(sessionService.getAuthToken()).deleteAttachment({id: $stateParams.id, message_id: message.id, attachment_id: attachment.id}, _deleteAttachmentSuccess, _deleteAttachmentFailure);
    }

    function preventDownload(message, attachment, $event) {
      $event.preventDefault()
      attachment.disableDownload = true;
      vm.currentAttachment = attachment;
      vm.currentMessage = message;
      var attachmentLink = $event.target.parentElement;

      attachmentLink.removeAttribute("ng-href");
    }

    function getMessage() {
      workqueueService(sessionService.getAuthToken()).show({id: $stateParams.id}, response => {
        vm.messageThread = response;
        if (vm.messageThread.status === 'draft') {
          let index = -1;

          for (let i = 0; i < vm.messageThread.messages.length && index == -1; i++) {
            if (vm.messageThread.messages[i].is_draft) {
              index = i;
            }
          }

          let message = vm.messageThread.messages[index];
          vm.messageThread.reply = message.body;
          vm.messageThread.question_count = message.question_count;
          vm.messageThread.call_count = message.call_count;
          vm.messageThread.disclosure_count = message.disclosure_count;
          vm.messageThread.ad_count = message.ad_count;
          vm.messageThread.policy_count = message.policy_count;
        }
      });
    }

    function getStaff() {
      workqueueService(sessionService.getAuthToken()).getStaff(response => vm.staff = response);
    }

    function hasDraft() {
      for (let i = 0; i < vm.messageThread.messages.length; i++) {
        if (vm.messageThread.messages[i].is_draft) {
          return true;
        }
      }

      return false;
    }

    function processMessage(message) {
      if (message.status === 'open') {
        updateMessage(message);
      } else if (message.status === 'draft') {
        publishDraft(message);
      } else {
        createMessage(message);
      }
      $state.reload();
    }

    function publishDraft(message) {
      vm.clearFormErrors();
      let msgThread = {
        status: 'in_progress',
        owner_read_flag: false,
        user_read_flag: true,
        owner_id: message.owner_id
      };
      workqueueService(sessionService.getAuthToken()).publishDraft({id: message.id, message_thread: msgThread, message_body: vm.messageThread.reply, question_count: vm.messageThread.question_count, call_count: vm.messageThread.call_count, disclosure_count: vm.messageThread.disclosure_count, ad_count: vm.messageThread.ad_count, policy_count: vm.messageThread.policy_count}, () => { Flash.create('success', 'Draft successfully published.'); $state.reload(); }, _updateMessageFailure);
    }

    function reassignCurrentMessage() {
      let msgThread = { owner_id: vm.reassignOwnerId };
      workqueueService(sessionService.getAuthToken()).update({id: vm.messageThread.id, message_thread: msgThread}, _reassignMessageSuccess, _reassignMessageFailure);
    }

    function saveAsDraft(messageThread) {
      vm.clearFormErrors();

      let message = {
        author_id: messageThread.owner_id,
        body: messageThread.reply,
        message_thread_id: messageThread.id,
        is_draft: true,
        question_count: messageThread.question_count,
        call_count: messageThread.call_count,
        disclosure_count: messageThread.disclosure_count,
        ad_count: messageThread.ad_count,
        policy_count: messageThread.policy_count
      };
      let msgThread = {
        status: 'draft',
        owner_id: messageThread.owner_id,
        owner_read_flag: true,
        user_read_flag: false
      };

      if (messageThread.attachments != null) {
        messageThread.attachments.upload = Upload.upload({
          url: `${config.complianceServicesApiEndpoint}/api/workqueue`,
          method: 'POST',
          data: { message: message, message_thread: msgThread, attachments: messageThread.attachments },
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        });

        messageThread.attachments.upload.then(response => {
          $timeout(() => {
            _saveMessageSuccess(response);
          });
        }, response => {
          _saveMessageFailure(response);
        });
      } else {
        workqueueService(sessionService.getAuthToken()).update({id: messageThread.id, message_thread: msgThread});
        workqueueService(sessionService.getAuthToken()).save({ id: messageThread.id }, message, () => {
          $state.reload();
          Flash.create('success', 'Draft successfully saved!');
        }, _saveMessageFailure);
      }
    }

    function updateDraft(messageThread) {
      vm.clearFormErrors();

      let message = {
        body: messageThread.reply,
        question_count: messageThread.question_count,
        call_count: messageThread.call_count,
        disclosure_count: messageThread.disclosure_count,
        ad_count: messageThread.ad_count,
        policy_count: messageThread.policy_count
      };

      if (messageThread.attachments != null) {
        messageThread.attachments.upload = Upload.upload({
          url: `${config.complianceServicesApiEndpoint}/api/workqueue/${messageThread.id}/update_draft`,
          method: 'PUT',
          data: { message: message, attachments: messageThread.attachments },
          headers: {
            'Authorization': `Token token=${sessionService.getAuthToken()}`
          }
        });

        messageThread.attachments.upload.then(response => {
          $timeout(() => {
            _saveMessageSuccess(response);
          });
        }, response => {
          _saveMessageFailure(response);
        });
      } else {
        workqueueService(sessionService.getAuthToken()).updateDraft({ id: messageThread.id }, { message: message }, () => {
          $state.reload();
          Flash.create('success', 'Draft successfully updated!');
        }, _saveMessageFailure);
      }
    }

    function markDuplicate(messageThread) {
      vm.clearFormErrors();
      let msgThread = { status: 'duplicate' };
      angular.element('#markDuplicateModal').modal('hide');
      workqueueService(sessionService.getAuthToken()).update({id: messageThread.id, message_thread: msgThread}, _markDuplicateSuccess, _markDuplicateFailure);
    }

    function _markDuplicateSuccess() {
      $state.go('application.compliance_services.workqueue');
      Flash.create('success', 'The request was successfully marked as duplicate!');
    }

    function _markDuplicateFailure() {
      Flash.create('danger', 'An error occured while marking this request as duplicate. Please try again later.');
    }
    function markAnswered(messageThread) {
      vm.clearFormErrors();
      let msgThread = { status: 'closed' };
      angular.element('#markAnsweredModal').modal('hide');
      workqueueService(sessionService.getAuthToken()).update({id: messageThread.id, message_thread: msgThread}, _markAnsweredSuccess, _markAnsweredFailure);
    }

    function _markAnsweredSuccess() {
      $state.go('application.compliance_services.workqueue');
      Flash.create('success', 'The request was successfully closed!');
    }

    function _markAnsweredFailure() {
      Flash.create('danger', 'An error occured while closing this request. Please try again later.');
    }

    function updateMessage(message) {
      vm.clearFormErrors();
      let msgThread = {
        status: 'in_progress',
        owner_read_flag: false,
        user_read_flag: true,
        owner_id: message.owner_id
      };
      workqueueService(sessionService.getAuthToken()).update({id: message.id, message_thread: msgThread}, _updateMessageSuccess, _updateMessageFailure);
    }

    function _deleteAttachmentSuccess(response) {
      vm.messageThread = response;
      $state.reload();
      Flash.create('success', 'The attachment was successfully deleted.');
    }

    function _deleteAttachmentFailure() {
      Flash.create('danger', 'An error occurred deleting the attachment. Please try again later.');
    }        

    function _reassignMessageSuccess(_response) {
      $state.reload();
      Flash.create('success', 'The message was reassigned!');
    }

    function _reassignMessageFailure(_response) {
      Flash.create('danger', 'The message could not be reassigned');
    }

    function _saveMessageSuccess(_response) {
      $state.reload();
      Flash.create('success', 'Reply was submitted');
    }

    function _saveMessageFailure(response) {
      Flash.create('danger', 'An error occurred sending message. Please correct the errors on the form and try again.');
      vm.setFormErrors(vm.messageForm, response);
    }

    function _updateMessageSuccess(_response) {
      $state.reload();
      Flash.create('success', 'The message was updated.');
    }

    function _updateMessageFailure(_response) {
      vm.setFormErrors(vm.messageForm, _response);
    }
  }
})();
